import PropTypes from 'prop-types';
import {Collapse} from '@emoney/kyber';
import './share-popover-panel.less';

const SharePopoverPanel = ({title, expanded, onClick, children}) => (
	<Collapse
		className="share-popover-panel"
		isShown={expanded}
		trigger={
			<div className="share-popover-panel-header" onClick={onClick}>
				<div>{title}</div>
				<i className={`fa fa-chevron-${expanded ? 'up' : 'down'}`} />
			</div>}
	>
		{children}
	</Collapse>
);

SharePopoverPanel.propTypes = {
	title: PropTypes.string,
	expanded: PropTypes.bool,
	onClick: PropTypes.func.isRequired
};

export default SharePopoverPanel;